<template>
  <div v-if="$apollo.loading">
    Carregando...
  </div>
  <div v-else class="grid col">

    <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
      Relatório de Planos de Contas
    </div>

    <div class="filters">
      <v-row>
        <v-col cols="12" lg="6">
          <v-menu
            v-model="startDateMenu"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="computedStartDateFormatted"
                label="Data Inicial"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="startDate"
              @input="menu = false"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" lg="6">
          <v-menu
            v-model="endDateMenu"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="computedEndDateFormatted"
                label="Data Final"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="endDate"
              @input="menu = false"
              locale="pt-br"
              @change="fetchChartOfAccountsReport(startDate, endDate)"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <!-- <v-autocomplete
        multiple
        chips
        small-chips
        label="Plano de Contas"
        :items="allCharts"
        item-text="name"
        item-value="id"
        @change="fetchProductionCostReportOfPeriod"
      >
        <template v-slot:selection="data">
          <v-chip
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            @click="data.select"
            @click:close="remove(data.item)"
          >
            {{ data.item.name }}
          </v-chip>
        </template>
      </v-autocomplete> -->
    </div>

    <div class="report" v-if="chartOfAccountsReport">
      <v-card outlined class="fill-height" :style="`grid-area: card1`">
        <!-- <div class="card-header">
          <v-card-title> {{ group.name }} </v-card-title>
          <div class="title font-weight-light">
            {{ numberToCurrency(group.cost) }}
          </div>
        </div> -->
        <v-treeview
          :items="chartOfAccountsReport.accounts"
          item-children="accounts"
          open-on-click
        >
          <template slot="prepend" slot-scope="{ item, leaf }">
            {{ item.code }}
          </template>
          <template slot="append" slot-scope="{ item, leaf }">
            {{ numberToCurrency(item.value) }}
          </template>
        </v-treeview>

        <!-- resultado: -->
      </v-card>

      <!-- <v-card outlined :style="`grid-area: card4`">
        <div class="card-header">
          <v-card-title>Custo Total</v-card-title>
          <div class="title font-weight-light">
            {{ numberToCurrency(productionCostReport.totalCost) }}
          </div>
        </div>
      </v-card> -->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import gql from 'graphql-tag'

export default {
  data() {
    return {
      startDate: moment()
        .startOf("month")
        .toISOString()
        .substr(0, 10),
      startDateMenu: false,
      endDate: moment().toISOString().substr(0, 10),
      endDateMenu: false,
      autocomplete: null,
      chartOfAccountsReport: null,
      context: null
    };
  },
  computed: {
    computedStartDateFormatted() {
      return this.startDate ? moment(this.startDate).format("DD/MM/YYYY") : "";
    },
    computedEndDateFormatted() {
      return this.endDate ? moment(this.endDate).format("DD/MM/YYYY") : "";
    }
  },
  created(){
    this.fetchChartOfAccountsReport(this.startDate, this.endDate)
  },
  methods: {
    fetchAllCharts: function(){
      this.$apollo
        .query({
          query: ALL_CHARTS_QUERY
        })
        .then(response => {
          console.log(response)
          // this.chartOfAccountsReport = response.data.accountContext.chartOfAccountsReport;
        })
        .catch(response => console.log(response));
    },
    fetchChartOfAccountsReport: function(startDate, endDate) {
      console.log("startDate", startDate);
      console.log("endDate", endDate);
      this.chartOfAccountsReport = null;
      this.$apollo
        .query({
          query: CHART_OF_ACCOUNTS_REPORT_QUERY,
          variables: {
            startDate: startDate,
            endDate: endDate
          }
        })
        .then(response => {
          console.log(response)
          this.chartOfAccountsReport = response.data.accountContext.chartOfAccountsReport;
        })
        .catch(response => console.log(response));
    },
    numberToCurrency: function(number) {
      return new Intl.NumberFormat("pt-br", {
        style: "currency",
        currency: "BRL"
      }).format(number);
    }
  }
};

const ALL_CHARTS_QUERY = gql `
  query {
    accountGlobalSharedContext{
      allCharts {
        name
        code
      }
    }
  }
`


// "2017-01-22"
// export
const CHART_OF_ACCOUNTS_REPORT_QUERY = gql `
  query ($startDate: ISO8601Date!, $endDate: ISO8601Date!){
    accountContext{
      chartOfAccountsReport(startDate: $startDate, endDate: $endDate) {
        accounts {
          code
          name
          value
          accounts {
            code
            name
            value
            accounts {
              code
              name
              value
              accounts {
                code
                name
                value
                accounts {
                  code
                  name
                  value
                  accounts {
                    code
                    name
                    value
                    accounts {
                      code
                      name
                      value
                      accounts {
                        code
                        name
                        value
                        accounts {
                          code
                          name
                          value
                          accounts {
                            code
                            name
                            value
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

</script>

<style lang="scss" scoped>
.grid {
  height: 100%;
  display: grid;
}

.report {
  height: 100%;
  grid-area: report;
}

.filters {
  grid-area: filters;
}

.card-header {
  display: flex;
  align-items: center;
}

.v-card {
}

@media (min-width: 640px) {
}
.grid {
  grid-template-columns: 100%;
  grid-template-rows: auto auto 1fr;
  grid-template-areas:
    "filters"
    "report";
}

@media (min-width: 768px) {
}

@media (min-width: 1024px) {
  .grid {
    grid-template-columns: minmax(100px, 1fr) minmax(100px, 1fr) minmax(
        100px,
        1fr
      );
    grid-template-rows: auto 1fr;
    grid-template-areas:
      "filters filters filters"
      "report report report";
  }

  .v-card {
    display: flex;
    flex-direction: column;
  }

  .v-treeview {
    flex-basis: 0;
    flex-grow: 1;
    overflow-y: auto;
  }
}

@media (min-width: 1280px) {
}
</style>
